(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7460],{

/***/ 62932:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/[category]",
      function () {
        return __webpack_require__(62481);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ SeveralBrandsCategoryPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88737);
/* harmony import */ var _components_layouts_severalBrandsWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73191);
/* harmony import */ var _components_severalbrands_clinicalTrialsComponents__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53325);
/* harmony import */ var _components_severalbrands_generalComponents__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62715);
/* harmony import */ var _components_severalbrands_debtReliefComponents__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53612);
/* harmony import */ var _components_severalbrands_highEndRehabComponents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44372);
/* harmony import */ var _components_severalbrands_tortsComponents__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88655);








var __N_SSP = true;
function SeveralBrandsCategoryPage() {
    const { domain , category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__/* .useDomainContext */ .w)();
    let content;
    switch(category?.slug){
        case "sb-clinical-trials":
        case "clinical-trials":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_clinicalTrialsComponents__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
            break;
        case "torts":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_tortsComponents__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
            break;
        case "sb-debt-relief":
        case "debt-relief":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_debtReliefComponents__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
            break;
        case "sb-high-end-rehab":
        case "high-end-rehab":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_highEndRehabComponents__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {});
            break;
        case "general":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_generalComponents__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
            break;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts_severalBrandsWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        domainInfo: domain,
        children: content
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [11943,83831,81711,73921,12358,49774,92888,40179], function() { return __webpack_exec__(62932); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);